import { useContext, useEffect} from 'react';
import { Container} from 'react-bootstrap';
import api from '../../app/api/agent'
import { GlobalStateContext } from '../../store/GlobalState';
import CustomNavBar from '../../components/CustomNavBar';
import { CircularProgress } from '@mui/material';
import Cookies from 'js-cookie';

 const Loading = () => {

    enum userRoleList {
        CustomerService,                
        CastcoEmployee,
        Customer
    }

    const globalState = useContext(GlobalStateContext);

    
    const isLoggedIn = (localStorage.accessToken && globalState?.accessToken !== "") || (Cookies.get(".AspNetCore.CookiesC1") !== undefined || Cookies.get(".AspNetCore.CookiesC1") !== "{}");

    useEffect(()=>{

      
            if(localStorage.accessToken){
                api.get(`/Account/userInfo`).then((response)=>{
                        if (response.status !== 200){
                            localStorage.removeItem("accessToken")
                            localStorage.removeItem("refreshToken")
                            localStorage.removeItem("expireAt")
                            localStorage.removeItem("role")
                            globalState?.setAccessToken('');
                            window.location.href='/'
                        }else{
                            if(isLoggedIn){
                                localStorage.setItem("role", userRoleList[response.data.role])
                                window.location.href="/form/list"
                            }else{
                                window.location.reload()
                            }
                        }
                        }).catch(()=>{
                            localStorage.removeItem("accessToken")
                            localStorage.removeItem("refreshToken")
                            localStorage.removeItem("expireAt")
                            localStorage.removeItem("role")

                            globalState?.setAccessToken('');
                            window.location.href='/'
                        })
            }else{
                api.get("/OIDC/getUserInfo",{withCredentials: true,}).then((response)=>{
                    if (response.status !== 200){
                            window.location.href='/'
                    }else{
                        if(isLoggedIn){
                            localStorage.setItem("role", userRoleList[response.data.role])
                            window.location.href="/form/list"
                        }else{
                            window.location.reload()
                        }
                    }
                    }).catch(()=>{
                        window.location.href='/'
                })
            }
        
    },[globalState, isLoggedIn])


  return (
    <Container style={{fontFamily:"Poppins", width:"95%", height:"100vh", background:"linear-gradient(45deg,rgba(255, 255, 255, 1) 0%, rgba(245, 255, 247, 1) 50%, rgba(222, 255, 232, 1) 100%)"}}>
    
    <CustomNavBar></CustomNavBar>
    <CircularProgress></CircularProgress>

    </Container>
  );
}

export default Loading;